<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h2>Feedback Manager</h2>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="white_box_edit shadow p-3">
          <div class="mt-4 url_list">
            <div class="table-responsive">
              <table class="table">
                <thead class="">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">URL</th>
                    <th scope="col">Content</th>
                    <th scope="col">Whatsapp link / Visible</th>
                    <th scope="col">Review link / Visible</th>
                    <th scope="col">Reviews</th>
                    <th scope="col">Version</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let i of all_urls; let index = index">
                    <th>{{ index + 1 }}</th>
                    <td>{{ i.url_name }}</td>
                    <td>{{ i.sms_content.substr(0, 25) }}</td>
                    <td>{{ i.Whatsapp_link.substr(0, 25) }} &nbsp; 
                      <span><i class="fa-solid fa-eye" *ngIf="i.show_whatsapp_link == 1"></i></span>
                      <span><i class="fa-solid fa-eye-slash" *ngIf="i.show_whatsapp_link == 0"></i></span>
                    </td>
                    <td>{{ i.review_link.substr(0, 25) }} &nbsp; 
                      <span><i class="fa-solid fa-eye" *ngIf="i.show_review_link == 1"></i></span>
                      <span><i class="fa-solid fa-eye-slash" *ngIf="i.show_review_link == 0"></i></span>
                    </td>
                    <td>
                      <span class="rev_cnt">{{ i.totalReviews }}</span>
                    </td>
                    <td>
                      <span *ngIf="i.version == 1">v2</span>
                      <span *ngIf="i.version == 0">v1</span>
                    </td>
                    <td>
                      <a (click)="editReview(content, i)">
                        <i class="fas fa-edit blue_action"></i></a>
                      &nbsp;
                      <!-- <span class="fut_pop"> <i class="fas fa-edit"></i></span> -->
                      <span class="del_url fa fa-trash" (click)="del_url_and_sms_content(i.id)"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-md-12">
        <!-- <app-add-feedback-manager-sub></app-add-feedback-manager-sub> -->

        <div class="title mb-4">
          <h2>Add URL</h2>
        </div>

        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="white_box_add shadow p-3">
              <div class="row">
                <div class="col-md-8">
                  <div class="nm_contact">
                    <h4>URL DETAILS</h4>
                    <form [formGroup]="url_form">
                      <div class="form-group position-relative">
                        <div class="input-group mt-3">
                          <input type="text" class="form-control" formControlName="url_name" placeholder="Company Name"
                          (keydown.space)="$event.preventDefault();" />
                          <div class="input-group-append">
                            <span class="input-group-text">
                              <i class="fa-regular fa-circle-question" (click)="helpSection(test, 1)">
                              </i>
                            </span>
                          </div>
                        </div>
                        <ng-container *ngIf="submitted && url_form_v.url_name.errors">
                          <p class="error-message" style="
                              padding: 0 0 0 10px;
                              font-size: 12px;
                              float: left;
                            " *ngIf="url_form_v.url_name.errors.required">
                            Company Name is required!
                          </p>
                        </ng-container>
                      </div>
                      <div class="form-group position-relative">
                          <div class="input-group mt-3">
                            <input type="text" class="form-control" formControlName="Whatsapp_link"
                          placeholder="Whatsapp link" />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <input type="checkbox" class="end_link" (change)="change_whatsapp_cb($event)">
                              </span>
                              <span class="input-group-text">
                                <i class="fa-regular fa-circle-question" (click)="helpSection(test, 2)">
                                </i>
                              </span>
                            </div>
                          </div>

                        <ng-container *ngIf="submitted && url_form_v.Whatsapp_link.errors">
                          <p class="error-message" style="
                              padding: 0 0 0 10px;
                              font-size: 12px;
                              float: left;
                            " *ngIf="url_form_v.Whatsapp_link.errors.required">
                            Whatsapp link is required!
                          </p>
                        </ng-container>
                      </div>
                      <div class="form-group position-relative">
                        <div class="input-group mt-3">
                          <input type="text" class="form-control" formControlName="review_link"
                          placeholder="Review link" />
                          <div class="input-group-append">
                            <span class="input-group-text">
                              <input type="checkbox" class="end_link" (change)="change_review_cb($event)">
                            </span>
                            <span class="input-group-text">
                              <i class="fa-regular fa-circle-question" (click)="helpSection(test, 3)">
                              </i>
                            </span>
                          </div>
                        </div>
                        
                        <ng-container *ngIf="submitted && url_form_v.review_link.errors">
                          <p class="error-message" style="
                              padding: 0 0 0 10px;
                              font-size: 12px;
                              float: left;
                            " *ngIf="url_form_v.review_link.errors.required">
                            Review link is required!
                          </p>
                        </ng-container>
                      </div>
                      <div class="form-group position-relative">
                        <div class="input-group mt-3">
                          <textarea class="form-control" rows="4" formControlName="sms_content"
                          placeholder="Thank you Content"></textarea>
                          <div class="input-group-append">
                            <span class="input-group-text">
                              <i class="fa-regular fa-circle-question" (click)="helpSection(test, 4)">
                              </i>
                            </span>
                          </div>
                        </div>

                        <ng-container *ngIf="submitted && url_form_v.sms_content.errors">
                          <p class="error-message" style="
                              padding: 0 0 0 10px;
                              font-size: 12px;
                              float: left;
                            " *ngIf="url_form_v.sms_content.errors.required">
                            SMS Content is required!
                          </p>
                        </ng-container>
                      </div>
                      <div class="form-group position-relative">
                        <div class="input-group mt-3">
                          <select class="form-control" formControlName="version">
                            <option value="" selected disabled>
                              Select version
                            </option>
                            <option value="0">Version 1</option>
                            <option value="1">Version 2</option>
                          </select>
                          <div class="input-group-append">
                            <span class="input-group-text">
                              <i class="fa-regular fa-circle-question" (click)="helpSection(test, 5)">
                              </i>
                            </span>
                          </div>
                        </div>
                    
                        <!-- <div class="tool_tip">
                          <i class="fa-regular fa-circle-question circle_icon">
                          </i>

                          <img loading="lazy" class="hov_img"
                          src="../../../../assets/images/new/image_2023_01_18T07_05_15_804Z.png"
                          alt=""
                        />
                      </div> -->

                        <ng-container *ngIf="submitted && url_form_v.version.errors">
                          <p class="error-message" style="
                              padding: 0 0 0 10px;
                              font-size: 12px;
                              float: left;
                            " *ngIf="url_form_v.version.errors.required">
                            Version is required!
                          </p>
                        </ng-container>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="nm_contact">
                    <a class="com_btn" (click)="add_url_and_sms_content_sub()">Save
                    </a>
                  </div>
                </div>

                <div class="col-md-12">
                  <!-- <app-feedback-manager-sub></app-feedback-manager-sub> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="login_me" role="dialog">
  <button type="button" style="outline: none;" class="close close_modal" (click)="modal.dismiss('Cross click')"
  data-dismiss="modal" aria-label="Close">
  <span aria-hidden="true">&times;</span> </button>
  <div class="modal-header">
    <h5 class="modal_title_2">
      <span>Edit Url</span>
    </h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="editFG">
      <div class="form-group">
        <label for="">Company Name</label>
        <input type="text" class="form-control" formControlName="url_name" placeholder="Company Name"
          (keydown.space)="$event.preventDefault();" disabled readonly />
        <label for="">Whatsapp link</label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" formControlName="Whatsapp_link" placeholder="Whatsapp link" />
          <div class="input-group-append">
            <span class="input-group-text">
              <input type="checkbox" class="end_link" (change)="change_whatsapp_cb($event)" [checked]="whatsapp_cb_checked">
            </span>
          </div>
        </div>
        <label for="">Review link</label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" formControlName="review_link" placeholder="Review link" />
          <div class="input-group-append">
            <span class="input-group-text">
              <input type="checkbox" class="end_link" (change)="change_review_cb($event)" [checked]="review_cb_checked">
            </span>
          </div>
        </div>
        <label for="">Version</label>
        <select class="form-control" formControlName="version">
          <option value="">Select version</option>
          <option value="0">Version 1</option>
          <option value="1">Version 2</option>
        </select>
        <label for="">Thank you Content</label>
        <textarea class="form-control" formControlName="sms_content" placeholder="Thank you Content" style="height: 200px;">
        </textarea>
      </div>
      <div class="text-center">
        <a class="edit_url" (click)="edit_update_feedback_manager()"> Update </a>
      </div>
    </form>
  </div>
  </div>
</ng-template>

<ng-template #test let-modal>
  <button type="button" style="outline: none;" class="close close_modal" (click)="modal.dismiss('Cross click')"
    data-dismiss="modal" aria-label="Close">
    <span aria-hidden="true">&times;</span> </button>
  <div class="modal-header">
    <h5 class="modal_title_2">
      <span>Help</span>
    </h5>
  </div>
  <div class="modal-body">
    <img loading="lazy" *ngIf="countdata == 5" class="hov_img" src="../../../../assets/images/new/review_link.png" alt="" />

    <img loading="lazy" *ngIf="countdata == 4" class="hov_img" src="../../../../assets/images/new/image_2023_01_17T12_06_44_112Z.png"
      alt="" />
    <img loading="lazy" *ngIf="countdata == 3" class="hov_img" src="../../../../assets/images/new/image_2023_01_17T12_05_49_633Z.png"
      alt="" />
    <img loading="lazy" *ngIf="countdata == 2" class="hov_img" src="../../../../assets/images/new/whatsapp_help.png" alt="" />
    <img loading="lazy" *ngIf="countdata == 1" class="hov_img" src="../../../../assets/images/new/reviewimgae.png" alt="" />
  </div>
</ng-template>